<div class="add-container">
  <div class="add-wrapper">

    <!-- ── En-tête ── -->
    <div class="add-header">
      <h3 class="add-title">Ajouter un regroupement d'expression de besoin</h3>
      <p class="add-subtitle">Associez plusieurs expressions de besoin et renseignez les informations complémentaires</p>
    </div>

    <form [formGroup]="regroupementExpressionBesoinForm" (ngSubmit)="onSubmit()" class="add-form">

      <!-- ── Section Expressions de besoin ── -->
      <div class="form-section">
        <div class="form-section__header">
          <div class="form-section__title-group">
            <span class="form-section__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                <circle cx="3" cy="6"  r="1.2" fill="currentColor"/>
                <circle cx="3" cy="12" r="1.2" fill="currentColor"/>
                <circle cx="3" cy="18" r="1.2" fill="currentColor"/>
              </svg>
            </span>
            <h4 class="form-section__title">Expressions de besoin associées</h4>
          </div>
          <app-ui-button
            type="button"
            label="Ajouter"
            variant="secondary"
            iconLeft="add"
            size="sm"
            (clicked)="addActivity()"
          />
        </div>

        <div class="activities-list" formArrayName="expressionBesoinSelectionnees">
          @for (control of activitesFormArray.controls; track $index) {
            <div class="activity-row">
              <div class="activity-row__number">{{ $index + 1 }}</div>
              <div class="activity-row__select">
                <app-select
                  placeholder="Sélectionner une expression de besoin"
                  [formControlName]="$index"
                  [options]="getAvailableActivitiesAsOptions($index)"
                  [loading]="loadingExpressions"
                />
              </div>
              <app-ui-button
                type="button"
                variant="danger"
                iconOnly="delete"
                size="sm"
                ariaLabel="Supprimer cette expression"
                [disabled]="activitesFormArray.length <= 1"
                (clicked)="removeActivity($index)"
              />
            </div>
          }
        </div>
      </div>

      <!-- ── Section Informations complémentaires (si > 1) ── -->
      @if (activitesFormArray.length > 1) {
        <div class="form-section" formGroupName="complementaryInfo">
          <div class="form-section__header">
            <div class="form-section__title-group">
              <span class="form-section__icon form-section__icon--info">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>
                  <line x1="12" y1="8" x2="12" y2="8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <line x1="12" y1="11" x2="12" y2="16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
              </span>
              <h4 class="form-section__title">Informations complémentaires</h4>
            </div>
          </div>

          <div class="form-grid">
            <app-input type="text" label="Libellé" formControlName="libelle" />
            <app-input type="text" label="Description" formControlName="description" />

            <app-select
              label="Superviseur"
              formControlName="supervisor"
              [options]="structureData"
              [loading]="loadingStructures"
            />
            <app-select
              label="Structure responsable"
              formControlName="structureResponsable"
              [options]="structureData"
              [loading]="loadingStructures"
            />

            <app-input type="text" label="Montant estimatif" formControlName="montantEstimatif" />
            <app-select
              label="Imputation budgétaire"
              formControlName="imputationBudgetaire"
              [options]="ligneBudgetaires"
              [loading]="loadingLignesBudgetaires"
            />

            <app-input type="text" label="Coût prévu N+1" formControlName="coutPrevuN1" />
            <app-input type="text" label="Prévision de décaissement N+2" formControlName="previsionDecaissementN2" />

            <app-input
              class="form-grid__full"
              label="Date prévisionnelle limite de transmission des spécifications techniques / TDR / DM"
              formControlName="datePrevision"
              type="date"
            />
            <app-input
              class="form-grid__full"
              label="Durée prévisionnelle d'exécution du marché (en jours)"
              formControlName="dureePrevisionExecutionMarche"
              type="text"
            />
          </div>
        </div>
      }

      <!-- ── Soumettre ── -->
      <div class="add-footer">
        <app-ui-button
          type="submit"
          label="Soumettre"
          variant="primary"
          iconLeft="check"
          [loading]="isLoading"
          [disabled]="isLoading"
        />
      </div>

    </form>
  </div>
</div>